/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable, of } from 'rxjs';
import { User, UserData } from '../../@core/interfaces/common/users';
import { tap, map, catchError } from 'rxjs/operators';
import { UserStore } from '../../@core/stores/user.store';
import { Injectable } from '@angular/core';
import { NbThemeService } from '@nebular/theme';

@Injectable()
export class InitUserService {
    constructor(protected userStore: UserStore,
        protected usersService: UserData,
        protected themeService: NbThemeService) { }

    initCurrentUser(): Observable<User> {
        return this.usersService.getCurrentUser()
            .pipe(
                tap((user: User) => {
                    if (user) {
                        this.userStore.setUser(user);
                        if (user.settings && user.settings.themeName) {
                            this.themeService.changeTheme(user.settings.themeName);
                        }
                    } else {
                        console.log('what the hell')
                    }
                }),
                catchError(err => {
                    console.log('An error occurred:', err);
                    // Here you can return a fallback value or another observable.
                    // For instance, you could return an EMPTY observable to end the stream when an error occurs:
                    return of(null);
                })
            );
    }
}
